/**
 * 开发环境
 */
export const dev = () => {
    return process.env.NODE_ENV == "development";
};

/**
 * 本地开发环境
 */
export const local = () => {
    return process.env.NODE_ENV == "local";
};

/**
 * 生产环境
 */
export const prod = () => {
    return process.env.NODE_ENV == "production";
};

/**
 * 测试环境
 */
export const test = () => {
    return process.env.NODE_ENV == "test";
};

/**
 * 测试环境
 */
export const pre = () => {
  return process.env.NODE_ENV == "pre";
};
/**
 * 获取当前开发环境
 */
export const env = () => {
    return process.env.NODE_ENV;
};

/**
 * 接口地址
 */
export const baseURL = () => {
    return process.env.VUE_APP_API_IP;
};

export const clientUrl = () => {
  if(dev() || local() || test()) {
    return 'https://master-s.theckb.com'
  }
  if(pre()){
    return 'https://pre-s.theckb.com'
  }
  return 'https://s.theckb.com'
}
/**
 * 静态文件地址
 */
// export const staticDomain = () => {
//     if (dev()) {
//         return "";
//     } else if (test()) {
//         return "";
//     } else if (prod()) {
//         return "";
//     } else {
//         return "";
//     }
// };
//
// export const interval = () => {
//     if (dev()) {
//         return 300000; // 5分钟
//     } else if (test()) {
//         return 300000; // 5分钟
//     } else if (prod()) {
//         return 5000; // 5秒钟
//     }
// };